import styled from 'styled-components';

import { TextField, MenuItem, Select } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export const AutocompleteStyled = styled(Autocomplete)`
  && {
    width: 100%;
  }
`;

export const MenuStyled = styled(MenuItem)`
  && {
    font-size: 2.3rem;
  }
`;

export const SelectStyled = styled(Select)`
  && {
    .MuiSelect-root {
      display: flex;
      align-items: center;

      font-size: 2.3rem;
    }

    .MuiSelect-icon {
      width: 4rem;
      height: 4rem;
      top: calc(50% - 16px);
      color: #000000;
    }
  }
`;

const InputStyled = styled(TextField)`
  && {
    margin: var(--espacamento-xsm) 0;
    label,
    > div {
      font-size: 2.3rem;
      text-align: left;

      svg {
        width: 4rem;
        height: 4rem;

        top: calc(50% - 16px);
      }
    }
    .MuiFormLabel-root.Mui-focused {
      color: ${(props) => (props.error ? '#f44336' : props.theme.cores.primaria)}
    }

    .MuiInput-underline:before {
      border-bottom: 1px solid;
      border-color: ${(props) => (props.error ? '#f44336' : props.theme.cores.secundaria)};
    }
    .MuiInput-underline.Mui-disabled:before {
      border-bottom: 1px dotted #000000;
    }

    .MuiInput-underline:after {
      border-bottom: 3px solid;
      border-color: ${(props) => (props.error ? '#f44336' : props.theme.cores.primaria)};
    }
    .MuiInput-underline.Mui-disabled:after {
      border-bottom: 1px dotted #000000;
    }

    .MuiFormHelperText-root {
      color: #f44336;
      font-size: 1.75rem;
    }

  }
`;

export default InputStyled;
